/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useContext } from "react";
import dayjs from "dayjs";
import { ERROR_TEXT } from "~/constants";
import { CustomerConfigContext, kantorQuery } from "~/context/CustomerConfig";
import { CurrencyLSKeys } from "~/context/CustomerConfig/utils";
import { showError } from "~/services/toast";
import { Currency } from "~/tools";

export function useCurrency() {
  const { config, update } = useContext(CustomerConfigContext);

  const currency = config?.currency || Currency.Eur;
  const baseCurrency = config?.defaultCurrency ?? Currency.Eur;

  if (config?.isDefaultPriority) {
    return { currency, baseCurrency };
  }

  const setCurrency = async (c: Currency) => {
    if (c !== Currency.Eur) {
      try {
        const kantorValue = await kantorQuery(c);

        const currencyRate = {
          rate: kantorValue.exchangeRate,
          expirationDate: dayjs().add(1, "day"),
        };

        localStorage.setItem(
          `${CurrencyLSKeys.RATE}${c}`,
          JSON.stringify(currencyRate)
        );
        localStorage.setItem(CurrencyLSKeys.CURRENCY, c);

        update({ ...config, currency: c });
      } catch {
        showError(`${c} ${ERROR_TEXT.rateNotFound}`);
      }
    } else {
      localStorage.setItem(CurrencyLSKeys.CURRENCY, c);
      update({ ...config, currency: c });
    }
  };

  return { currency, setCurrency, baseCurrency };
}
